import { jsx as _jsx } from "react/jsx-runtime";
import { useWindowSize } from "usehooks-ts";
import { useUiIsLocked } from "../hooks/useUiIsLocked";
const size = 1;
export const LockedUiBorder = () => {
    const windowSize = useWindowSize();
    const uiIsLocked = useUiIsLocked();
    return uiIsLocked ? (_jsx("graphics", { zIndex: 10001, eventMode: "none", label: "LOCKED_UI_BORDER", draw: (graphics) => {
            graphics.clear();
            graphics
                .rect(1, 0, windowSize.width - size, windowSize.height - size)
                .stroke({ width: size, color: 0xff0000 });
        } })) : null;
};
//# sourceMappingURL=LockedUiBorder.js.map